

<app-croud-liste-prix #croud></app-croud-liste-prix>
<div class="col-xl-10 col-lg-10 col-md-10"></div>

<div class="">
  <div class="card-body p-0">
    <div *ngIf="isLoading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div *ngIf="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div *ngIf="!isLoading && !error">
        <div class="container col-lg-12 mb-3 mt-2">
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="" style="font-size: 15px">Listes de prix</h5>
                <button class="btn btn-primary" (click)="addList()" >+ Ajouter</button>
            </div>
        </div>
      <div class="table-header">
        <table class="table align-middle" style="margin-top: 0;">
          <thead class="custom-thead">
            <tr>
              <th>NOM</th>
              <th>ÉTAT</th>
              <th>ACTION</th>
            </tr>
          </thead>
        </table>
      </div>

      <div class="table-body p-0">
        <table class="table align-middle">
          <tbody>
            <tr *ngFor="let prix of prixList" style="border-bottom: 1px solid #dee2e6;">
              <td class="align-middle">{{ prix.libelle }}</td>
              <td>
                <div class="custom-control custom-switch custom-control-success d-inline-block" style="margin:0; cursor: pointer;"
                     (click)="openEtatModal(prix, $event, 'etat')">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    [id]="'customSwitch' + prix.id"
                    [checked]="prix.statut"
                    [disabled]="isLoading"
                    [ngModelOptions]="{standalone: true}"
                  />
                  <label class="custom-control-label" [for]="'customSwitch' + prix.id"></label>
                </div>
              </td>
              <td class="text-center align-middle">
                <button
                  class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                  style="width: 30px; height: 30px; padding: 0;"
                  (click)="openEtatModal(prix, $event, 'update')"
                  [disabled]="isLoading"
                >
                  <i data-feather="edit" class="feather-icon"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
